import type { Translate } from '../i18n/index.js';
import { theme } from '../theme.js';
import type { GlanceTarget } from '../state.js';

interface GlanceDrawerProps {
  target: GlanceTarget;
  t: Translate;
  onClose: () => void;
}

/** On-demand contact read. Fired by the click, never polled. */
export function GlanceDrawer({ target, t, onClose }: GlanceDrawerProps) {
  const rows = [
    { label: t('Outstanding balance'), value: 'QAR 18,450.00', endpoint: 'GET /Contacts/{ContactID}' },
    { label: t('Last document from here'), value: `INV-0241 · ${t('DRAFT')}`, endpoint: 'local' },
    { label: t('Default currency'), value: 'QAR', endpoint: 'cached' },
    { label: t('Sales tax default'), value: t('Tax on sales (5%)'), endpoint: 'cached' },
  ];

  return (
    <div
      style={{
        position: 'absolute',
        insetBlock: 0,
        insetInlineEnd: 0,
        width: 'min(340px, 90%)',
        background: theme.surface,
        boxShadow: '-18px 0 46px rgba(34,30,42,.14)',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        zIndex: 10,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '16px', fontWeight: 600, letterSpacing: '-.01em' }}>{target.name}</div>
          <div style={{ fontFamily: theme.fontMono, fontSize: '11.5px', color: theme.textMuted, marginTop: '3px' }}>
            {target.acct}
          </div>
        </div>
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            width: '28px',
            height: '28px',
            border: 0,
            background: '#F0F0F2',
            borderRadius: theme.radiusPill,
            color: '#515C6B',
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            flex: '0 0 auto',
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {rows.map((row) => (
          <div key={row.label}>
            <div style={{ fontSize: '11.5px', color: theme.textMuted }}>{row.label}</div>
            <div style={{ fontSize: '13.5px', fontWeight: 600, marginTop: '2px' }}>{row.value}</div>
            <div style={{ fontFamily: theme.fontMono, fontSize: '10.5px', color: theme.textFaint, marginTop: '2px' }}>
              {row.endpoint}
            </div>
          </div>
        ))}
      </div>

      <div style={{ flex: 1 }} />
      <div style={{ fontSize: '11.5px', color: theme.textSubtle, lineHeight: 1.6 }}>
        {t('Fetched just now, on this click only — not polled.')}
      </div>
    </div>
  );
}
